import { atom } from 'jotai';

export const validationErrorsAtom = atom(new Set<string>());
export const isValidationDialogOpenAtom = atom(false);

export type TemplateValidationError = {
  filterName: string;
  fieldName: string;
};

export const templateValidationErrorsAtom = atom<TemplateValidationError[]>([]);
